<div class="h-full flex flex-col {{ class }}">
  <div class="flex-1 overflow-y-auto flex flex-col gap-2 justify-between">
    <app-mb-case-timeline-skeleton *ngIf="isLoading"/>
    <nz-timeline *ngIf="!isLoading" class="py-4">
      @for (followUp of timeline; track followUp) {
        <!-- Remove check if the followup action is INVITED_TO_CASE  because citizen are not invited here -->
        @if (followUp.action === 'INVITED_TO_CASE') {
          <div></div>
        } @else {
          <nz-timeline-item [nzDot]="dotTemplate">
            <app-mb-timeline-item
              [followUp]="followUp"
              [organizationId]="organizationId"
              (downloadDocument)="onDownloadDocument($event)"
            />
          </nz-timeline-item>
        }
      }
      <ng-template #dotTemplate>
        <div class="w-1.5 h-1.5 bg-mbaza-gray-dark rounded-full"></div>
      </ng-template>
    </nz-timeline>
  </div>
</div>
